import { Button, Row } from 'components'
import { DealContext } from 'context'
import { STATUS_TYPES } from 'helpers/constants'
import React from 'react'
import { useContext } from 'react'
import { useNavigate, useLocation } from 'react-router'
import styles from './deals.module.scss'

const ViewDealFooter = (props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const backPath = location.state?.from === 'deposit-receipts' ? '/deals/deposit-receipts' : '/deals'
  const {
    dealStatus,
    loading = false,
    isAdmin = false,
    onSave = console.log,
    onEditDeal = console.log,
    onSubmitDraft = console.log,
    adminSaveLoading = false
  } = props
  const { isEdit, deal } = useContext(DealContext)

  return (
    <Row gap={20} className={styles.dealFooter}>
      {isAdmin ? (
        <>
          <Button form onClick={() => navigate(backPath)}>
            Back to Dashboard
          </Button>
          <Button
            className={styles.dealFooterButton}
            form
            loading={loading || adminSaveLoading}
            onClick={async () => {
              if (isEdit) {
                try { await onEditDeal() } catch (e) { /* validation failed, still save admin */ }
              }
              onSave()
            }}>
            Save Deal
          </Button>

        </>
      ) : (
        <>
          <Button form onClick={() => navigate(backPath)}>
            Back to Dashboard
          </Button>
          {isEdit && (
            <>
              <Button
                form
                style={{ width: 110 }}
                loading={loading && dealStatus === STATUS_TYPES.draft}
                onClick={onEditDeal}>
                Save Deal
              </Button>
              {deal?.status === STATUS_TYPES.draft && (
                <Button
                  form
                  style={{ width: 110 }}
                  loading={loading && dealStatus === STATUS_TYPES.submitted}
                  onClick={onSubmitDraft}>
                  Submit Draft
                </Button>
              )}
            </>
          )}
        </>
      )}
    </Row>
  )
}

export default ViewDealFooter
